module.exports = __webpack_public_path__ + "img/elearning-online-gray.20888da3.svg";